
class TimeUtils {
  nbOfDaysBeforePresumedEndDate(value) {
    let dayOut = new Date(value)
    let today = new Date()
    let difference = dayOut.getTime() - today.getTime()
    if (difference < 0) {
      return "Date dépassée"
    } else {
      let days = Math.round(difference / (1000 * 3600 * 24))

      if (dayOut.getFullYear() === today.getFullYear()
        && dayOut.getMonth() === today.getMonth()
        && dayOut.getDate() === today.getDate()
      ) {
        return "Aujourd'hui"
      }

      return "Dans " + days + " jour(s)"
    }
  }

  nbDaysRealised(start, end){
    if(end == null){
      end = new Date().getTime()
    }
    let difference = end - start
    if(difference < 0){
      return 0
    }else{
      return Math.round(difference / (1000 * 3600 * 24))
    }
  }

  setAnimalAge(value){
    if(value != null){
      let dayOfBirth = new Date(value).getTime()
      let today = new Date().getTime()
      let difference = today - dayOfBirth
      let years = Math.round(difference / (1000 * 3600 * 24 * 365))
      if(years > 0) return years + " an(s)"
      let months = Math.round(difference / (1000 * 3600 * 24 * 30))
      if(months > 0) return months + " mois"
      let days = Math.round(difference / (1000 * 3600 * 24))
      return days + " jour(s)"
    }
    return value
  }
}

export default new TimeUtils()



// WEBPACK FOOTER //
// ./src/utils/TimeUtils.js